import MainAnnouncementDetail from "../components/announcement-details/main-announcement-detail";

function AnnouncementDetail() {
  return (
    <div className="w-[95%] mx-auto">
        
      <MainAnnouncementDetail />
    </div>
  );
}

export default AnnouncementDetail;